import ColorPalette from "@acl-services/sriracha-color-palette/dist/ColorPalette";

angular.module("acl.visualizer.color", []).service("ColorPalette", () => ColorPalette);
